module.exports = {
	"permanent": "Permanent",
	"buttons": {
		"cancel": "Cancel",
		"close": "Close",
		"copy": "Copy",
		"copyFile": "Copy file",
		"copyToClipboard": "Copy to clipboard",
		"create": "Create",
		"delete": "Delete",
		"download": "Download",
		"info": "Info",
		"more": "More",
		"move": "Move",
		"moveFile": "Move file",
		"new": "New",
		"next": "Next",
		"ok": "OK",
		"replace": "Replace",
		"previous": "Previous",
		"rename": "Rename",
		"reportIssue": "Report Issue",
		"save": "Save",
		"search": "Search",
		"select": "Select",
		"share": "Share",
		"publish": "Publish",
		"selectMultiple": "Select multiple",
		"schedule": "Schedule",
		"switchView": "Switch view",
		"toggleSidebar": "Toggle sidebar",
		"update": "Update",
		"upload": "Upload",
		"permalink": "Get Permanent Link"
	},
	"success": {
		"linkCopied": "Link copied!"
	},
	"errors": {
		"forbidden": "You're not welcome here.",
		"internal": "Something really went wrong.",
		"notFound": "This location can't be reached."
	},
	"files": {
		"folders": "Folders",
		"files": "Files",
		"body": "Body",
		"clear": "Clear",
		"closePreview": "Close preview",
		"home": "Home",
		"lastModified": "Last modified",
		"loading": "Loading...",
		"lonely": "It feels lonely here...",
		"metadata": "Metadata",
		"multipleSelectionEnabled": "Multiple selection enabled",
		"name": "Name",
		"size": "Size",
		"sortByName": "Sort by name",
		"sortBySize": "Sort by size",
		"sortByLastModified": "Sort by last modified"
	},
	"help": {
		"click": "select file or directory",
		"ctrl": {
			"click": "select multiple files or directories",
			"f": "opens search",
			"s": "save a file or download the directory where you are"
		},
		"del": "delete selected items",
		"doubleClick": "open a file or directory",
		"esc": "clear selection and/or close the prompt",
		"f1": "this information",
		"f2": "rename file",
		"help": "Help"
	},
	"login": {
		"password": "Password",
		"submit": "Login",
		"username": "Username",
		"wrongCredentials": "Wrong credentials"
	},
	"prompts": {
		"copy": "Copy",
		"copyMessage": "Choose the place to copy your files:",
		"currentlyNavigating": "Currently navigating on:",
		"deleteMessageMultiple": "Are you sure you want to delete {count} file(s)?",
		"deleteMessageSingle": "Are you sure you want to delete this file/folder?",
		"deleteTitle": "Delete files",
		"displayName": "Display Name:",
		"download": "Download files",
		"downloadMessage": "Choose the format you want to download.",
		"error": "Something went wrong",
		"fileInfo": "File information",
		"filesSelected": "{count} files selected.",
		"lastModified": "Last Modified",
		"move": "Move",
		"moveMessage": "Choose new house for your file(s)/folder(s):",
		"newDir": "New directory",
		"newDirMessage": "Write the name of the new directory.",
		"newFile": "New file",
		"newFileMessage": "Write the name of the new file.",
		"numberDirs": "Number of directories",
		"numberFiles": "Number of files",
		"replace": "Replace",
		"replaceMessage": "One of the files you're trying to upload is conflicting because of its name. Do you wish to replace the existing one?\n",
		"rename": "Rename",
		"renameMessage": "Insert a new name for",
		"show": "Show",
		"size": "Size",
		"schedule": "Schedule",
		"scheduleMessage": "Pick a date and time to schedule the publication of this post.",
		"newArchetype": "Create a new post based on an archetype. Your file will be created on content folder."
	},
	"settings": {
		"admin": "Admin",
		"administrator": "Administrator",
		"allowCommands": "Execute commands",
		"allowEdit": "Edit, rename and delete files or directories",
		"allowNew": "Create new files and directories",
		"allowPublish": "Publish new posts and pages",
		"avoidChanges": "(leave blank to avoid changes)",
		"changePassword": "Change Password",
		"commands": "Commands",
		"commandsHelp": "Here you can set commands that are executed in the named events. You write one command per line. If the event is related to files, such as before and after saving, the environment variable \"FILE\" will be available with the path of the file.\n",
		"commandsUpdated": "Commands updated!",
		"customStylesheet": "Custom Stylesheet",
		"examples": "Examples",
		"globalSettings": "Global Settings",
		"language": "Language",
		"lockPassword": "Prevent the user from changing the password",
		"newPassword": "Your new password",
		"newPasswordConfirm": "Confirm your new password",
		"newUser": "New User",
		"password": "Password",
		"passwordUpdated": "Password updated!",
		"permissions": "Permissions",
		"permissionsHelp": "You can set the user to be an administrator or choose the permissions individually. If you select \"Administrator\", all of the other options will be automatically checked. The management of users remains a privilege of an administrator.\n",
		"profileSettings": "Profile Settings",
		"ruleExample1": "prevents the access to any dot file (such as .git, .gitignore) in every folder.\n",
		"ruleExample2": "blocks the access to the file named Caddyfile on the root of the scope.",
		"rules": "Rules",
		"rulesHelp1": "Here you can define a set of allow and disallow rules for this specific user. The blocked files won't show up in the listings and they wont be accessible to the user. We support regex and paths relative to the users scope.\n",
		"rulesHelp2": "Each rule goes in one different line and must start with the keyword {0} or {1}. Then you should write {2} if you are using a regular expression and then the expression or the path.\n",
		"scope": "Scope",
		"settingsUpdated": "Settings updated!",
		"user": "User",
		"userCommands": "Commands",
		"userCommandsHelp": "A space separated list with the available commands for this user. Example:\n",
		"userCreated": "User created!",
		"userDeleted": "User deleted!",
		"userManagement": "User Management",
		"username": "Username",
		"users": "Users",
		"userUpdated": "User updated!"
	},
	"sidebar": {
		"help": "Help",
		"logout": "Logout",
		"myFiles": "My files",
		"newFile": "New file",
		"newFolder": "New folder",
		"settings": "Settings",
		"siteSettings": "Site Settings",
		"hugoNew": "Hugo New",
		"preview": "Preview"
	},
	"search": {
		"images": "Images",
		"music": "Music",
		"notSupportedCommand": "This is a not supported command.",
		"pdf": "PDF",
		"pressToExecute": "Press enter to execute.",
		"pressToSearch": "Press enter to search.",
		"search": "Search...",
		"searchOrCommand": "Search or execute a command...",
		"searchOrSupportedCommand": "Search or prepend '$' and use one of your supported commands:",
		"typeCommand": "Type and press enter to execute.",
		"typeSearch": "Type and press enter to search.",
		"types": "Types",
		"video": "Video",
		"writeToSearch": "Write here to search"
	},
	"languages": {
		"ar": "العربية",
		"en": "English",
		"it": "Italiano",
		"fr": "Français",
		"pt": "Português",
		"ptBR": "Português (Brasil)",
		"ja": "日本語",
		"zhCN": "中文 (简体)",
		"zhTW": "中文 (繁體)",
		"es": "Español",
		"de": "Deutsch",
		"ru": "Русский",
		"pl": "Polski",
		"ko": "한국어"
	},
	"time": {
		"unit": "Time Unit",
		"seconds": "Seconds",
		"minutes": "Minutes",
		"hours": "Hours",
		"days": "Days"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en.yaml
// module id = 287
// module chunks = 0